import React, { useState, useEffect } from 'react';
import { taskVideoList } from '../../../../actions/majorProjects';
import { Spin, Empty } from 'antd';
import Scrollbars from 'react-custom-scrollbars';
import task from '../../images/task.png';
import UploadItem from '../../../resource-wrap/common-wrap/pictureItem/upLoadItem';

//任务视频页面
const TaskVideo = (props) => {

    const [loading, setLoading] = useState(false)
    const [videoList, setVideoList] = useState([])

    useEffect(() => {
        search()
    }, [])

    const search = () => {
        let formData = {
            id: props.id, ///项目id
            resourceType: 3
        }
        setLoading(true)
        taskVideoList(formData, function (res) {
            if (res.code === 0) {
                setLoading(false)
                let data = []
                res.data && res.data.map((item) => data.push({ taskName: item.interview.title, videoData: item.video }))
                setVideoList(data)
            }
        })
    }

    return (
        <Scrollbars style={{ height: 570}}>
        <div className="taskVideo taskPicture">
                {
                    loading ? <Spin className="loading" /> :
                    videoList.length === 0 ? <Empty className="noData" /> : 
                    videoList.map((item, index) => (
                        <div className="box" style={{background:'white'}} key={index}>
                            <div className="part_1">
                                <img src={task} alt="" />
                                <span>{item.taskName}</span>
                            </div>
                            <div className="part_2">
                                <UploadItem fileList={item.videoData} fileType="视频" showIcon={['eye', "play",'download']} />
                            </div>
                        </div>
                    ))
                }
        </div>
        </Scrollbars>
    )
}

export default TaskVideo